import { render, staticRenderFns } from "./NewRole.vue?vue&type=template&id=434d746d&"
import script from "./NewRole.vue?vue&type=script&lang=js&"
export * from "./NewRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports